import dayjs from 'dayjs';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { VerifMateriel } from '../verif-materiel.model';
import { UserEvent } from './user-event.model';

export class DebutVacationTourneeEvent extends UserEvent {
  public static NAME = 'DEBUT_TOURNEE_EVENT';
  constructor(
    public idCreneau: string,
    public idVacation: string,
    public debut: dayjs.Dayjs,
    public verificationMateriel?: VerifMateriel,
    public champsPersonnalises: ChampCompteRendu[] = [],
    public idConsignes: string[] = [],
    coordinates?: Coordinates
  ) {
    super(DebutVacationTourneeEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: DebutVacationTourneeEvent): DebutVacationTourneeEvent {
    return new DebutVacationTourneeEvent(
      obj.idCreneau,
      obj.idVacation,
      dayjs(obj.debut),
      obj.verificationMateriel,
      obj.champsPersonnalises,
      obj.idConsignes,
      obj.coordinates
    );
  }
}
